import { CreateDefaultUser } from "./createDefaultUser";

export const defaultTenantModel = {
  id: 0,
  name: "",
  tenancyName: "",
  isActive: true,
  connectionString: null,
  defaultUser:null,
  residentStatus:null
};

export class  TenantModel {
  id: number;
  name: string;
  tenancyName: string;
  isActive: boolean;
  connectionStringCheckBox?:boolean;
  connectionString?: string | null;
  defaultUser?:CreateDefaultUser | null;
  residentStatus:{name:string,code:string}|null;

  constructor(data = defaultTenantModel) {
    this.name = data.name;
    this.tenancyName = data.tenancyName;
    this.id = data.id;
    this.isActive = data.isActive;
    this.connectionString  = data.connectionString;
    this.defaultUser = data.defaultUser;
    this.residentStatus = data.residentStatus;
  }
}
